import { WALL_SLOTS, type WallSlot } from "./hex.ts";
import { ACTIVE_CANDIDATE_SLUGS, type Slug } from "../../lib/candidates.ts";

// The 22 walls: the active candidate booths · 13 expert-topic billboards · 1
// methodology board · 1 "experts consulted" roster · 2 sponsor walls — around
// the room. (Partners are floor tables scattered across the room, not walls —
// see scene/partners.ts.)

// All 13 topic ids, in display order (matches packages/experts lib/topics.ts).
export const TOPIC_IDS = [
  "economia-estado",
  "salud",
  "pensiones",
  "trabajo",
  "energia",
  "educacion",
  "pobreza-subsidios",
  "cuidado",
  "crecimiento",
  "finanzas-tributaria",
  "seguridad-paz",
  "relaciones-exteriores",
  "derechos-digitales",
];

// Fixed slot assignment (22 walls). The two active candidates sit at OPPOSING
// ends — slots 5 and 16 are diametrically across the room (the player spawns at
// +z facing -z, so slot 16 is straight ahead and slot 5 is directly behind).
// The two sponsor walls sit mid-gap (18,19); the methodology + roster pair sits
// at 14,15; topics fill the rest in order. (Order matches ACTIVE_CANDIDATE_SLUGS:
// abelardo → slot 5, ivan → slot 16.)
const CANDIDATE_SLOTS = [5, 16];
const METHODOLOGY_SLOT = 14;
const ROSTER_SLOT = 15;
const SPONSOR_SLOTS = [18, 19];

export interface CandidateWall {
  slot: WallSlot;
  slug: Slug;
}
export interface ExpertWall {
  slot: WallSlot;
  topicId: string;
}

const reserved = new Set([
  ...CANDIDATE_SLOTS,
  METHODOLOGY_SLOT,
  ROSTER_SLOT,
  ...SPONSOR_SLOTS,
]);
const topicSlotIndices = WALL_SLOTS
  .map((s) => s.index)
  .filter((i) => !reserved.has(i)); // the 13 remaining

export const candidateWalls: CandidateWall[] = ACTIVE_CANDIDATE_SLUGS.map((
  slug,
  i,
) => ({
  slot: WALL_SLOTS[CANDIDATE_SLOTS[i]],
  slug,
}));

export const expertWalls: ExpertWall[] = TOPIC_IDS.map((topicId, i) => ({
  slot: WALL_SLOTS[topicSlotIndices[i]],
  topicId,
}));

export const methodologyWall: WallSlot = WALL_SLOTS[METHODOLOGY_SLOT];
export const rosterWall: WallSlot = WALL_SLOTS[ROSTER_SLOT];
export const sponsorWalls: WallSlot[] = SPONSOR_SLOTS.map((i) => WALL_SLOTS[i]);
